import template from '../../mad-id.module.scss';
import Image from 'next/image';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './benefits-section.module.scss'
import { IBenefitsMad } from '../../mad-id.state';

interface IBenefitsSectionProps {
    image: string;
    title: string;
    benefits: IBenefitsMad[];
}

const BenefitsSection = ({ image, title, benefits }: IBenefitsSectionProps) => {

    return (
        <>
            <hr />
            <section className={`${template.section}`}>
                <div className={`${template.container} ${style.benefits}`}>
                    <div className={`${template.title} ${template.title} ${template.title_medium} ${template.text_align_center} ${template.margin_bot30px}`}>
                        {title}
                    </div>
                    <div className={`${style.benefits__items} ${template.margin_bot40px}`}>
                        {
                            benefits.map((item: IBenefitsMad, index: number) => {
                                return (
                                    <InView key={index} triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.benefits__item} ${animations.scroll__animation}`}>
                                                    <div className={`${template.margin_bot24px}`}>
                                                        <Image src={item.icon} alt={item.iconAlt} width={"32px"} height={"32px"} />
                                                    </div>
                                                    <div className={`${style.benefits__item__text}`}>
                                                        {item.text}
                                                    </div>
                                                </div>
                                            )
                                        }}
                                    </InView>
                                )
                            })
                        }
                    </div>
                    <InView triggerOnce={true}>
                        {({ inView, ref, entry }: any) => {
                            if (inView) {
                                entry.target.classList.add(animations.active);
                            }
                            return (
                                <div ref={ref} className={`${animations.scroll__animation} ${style.image}`}>
                                    <Image src={image} alt={'preview benefits images'} layout={'fill'} sizes="800 600 400 200" />
                                </div>
                            )
                        }}
                    </InView>
                </div>
            </section>
        </>
    )
}

export default BenefitsSection;
